import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { StickerPackPlaceholder } from '@gem/components';
import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';
import { Button, PopupFooter } from '@gem/ui-kit';

import { PopupHeader } from './PopupHeader/PopupHeader';
import { StickerCategory } from './StickerCategory/StickerCategory';
import {
  IStickerPackPopupParams,
  useStickerPackPopupPresenter,
} from './StickerPackPopup.presenter';
import styles from './StickerPackPopup.styles.m.css';
import { Stickers } from './Stickers/Stickers';

export const StickerPackPopup: FC<ICommonPopupsProps<IStickerPackPopupParams>> = observer(
  (props) => {
    const presenter = useStickerPackPopupPresenter(props);
    const { t } = useTranslation();

    return (
      <Popup
        isOpened={presenter.isAvailableToShow}
        className={styles.container}
        onClose={presenter.onClose}
      >
        <PopupHeader
          onCopyClick={presenter.copyLink}
          onBackClick={presenter.hasBackButton ? presenter.onBack : null}
          onClose={presenter.onClose}
        />
        {presenter.isLoading ? (
          <StickerPackPlaceholder />
        ) : (
          presenter.isAvailableToShow &&
          presenter.pack !== null && (
            <>
              <StickerCategory
                iconUrl={presenter.pack.stickerPack.iconUrl}
                displayName={presenter.pack.stickerPack.displayName}
                stickersCount={presenter.pack.stickers.length}
              />
              <Stickers
                stickerPackId={presenter.pack.stickerPack.id}
                stickers={presenter.pack.stickers}
                onClick={presenter.sendSticker}
              />
              <PopupFooter>
                {presenter.isSharable ? (
                  <Button
                    theme={presenter.isSharable ? 'primary' : 'fixed-color'}
                    isLoading={presenter.isProgress}
                    isDisabled={presenter.isProgress}
                    onClick={presenter.toggle}
                  >
                    {presenter.isAddedPack ? t('common_remove') : t('add_button')}
                  </Button>
                ) : (
                  <div className={styles.privateTitle}>{t('common_private_sticker_pack')}</div>
                )}
              </PopupFooter>
            </>
          )
        )}
      </Popup>
    );
  }
);
